export default __webpack_public_path__ + "static/media/warning--height-restriction--g4.32ae1bcd.png";